import {
    SET_SAVE_ADMIN_TASK_VALUE,
    SET_SAVED_STATUS,
    SET_SAVE_ASSET_ADMIN_TASK_VALUE,
    SET_SAVE_AFE_ADMIN_TASK_VALUE
 } from "./AdminTaskType"
 
 const initialState = {
    SavedAdminTaskValue: {},
    savedStatus:[],
    SavedAssetAdminTaskValue: {}
 }
 
 
 const reducer = (state = initialState, action: any) => {
     switch (action.type) {
         case SET_SAVE_ADMIN_TASK_VALUE:
             return {
                 ...state,
                 SavedAdminTaskValue: action.SavedAdminTaskValue
             };
        case SET_SAVED_STATUS:
        return {
            ...state,
            savedStatus: action.savedStatus
        };
        case SET_SAVE_ASSET_ADMIN_TASK_VALUE:
             return {
                 ...state,
                 SavedAssetAdminTaskValue: action.SavedAssetAdminTaskValue
             };
        case SET_SAVE_AFE_ADMIN_TASK_VALUE:
            return {
                ...state,
                SavedAfeAdminTaskValue: action.SavedAfeAdminTaskValue
            };
         default:
             return state;
     }
 };
 
 export default reducer;